module.exports = __webpack_public_path__ + "static/media/kids.dc56fcee.jpg";